// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取单个物品信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /goods-apply/info */
export async function goodsApplyInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.goodsApplyInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultGoodsApplyResp>('/goods-apply/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取物品信息列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /goods-apply/list */
export async function goodsApplyListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.goodsApplyListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListGoodsApplyResp>('/goods-apply/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改物品收货地址 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /goods-apply/modify-address */
export async function goodsApplyModifyAddressUsingPOST(
  body: API.GoodsApplyAddressReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/goods-apply/modify-address', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
